import { departmentQueryOptions } from '@features/groups/queries'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/faculty/$departmentId')({
    component: Outlet,
    loader: async ({ params, context }) => {
        return context.queryClient.ensureQueryData(departmentQueryOptions({ mode: 'id', id: params.departmentId }))
    },
    staticData: {
        crumb: {
            dynamicLabel(match) {
                return `${match.loaderData?.departmentName} (Department)`
            },
        }
    }
})